import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    private count = 0;
    private stateChangeSource: Subject<boolean> = new Subject<boolean>();
    private stateChange: Observable<boolean> = this.stateChangeSource.asObservable();

    constructor() { }

    /**
     * Loader state change (on/off) event.
     */
    getStateChange() {
        return this.stateChange;
    }

    /**
     * Increments loader counter and starts loader if it hasn't been started yet.
     */
    start() {
        if (!this.count) {
            this.stateChangeSource.next(true);
        }

        ++this.count;
    }

    /**
     * Decrements loader counter and stops loader if it has been started.
     */
    stop() {
        this.count = Math.max(this.count - 1, 0);

        setTimeout(() => {
            if (!this.count) {
                this.stateChangeSource.next(false);
            }
        });
    }
}
